import React from "react";
import './ResultChart.css';

function ResultAbout({title, about}) {
    return (
        <div className="d-flex align-items-center">
            <p className=" result-text mb-0 me-2" dangerouslySetInnerHTML={{__html: title + ':'}}></p>
            <p className=" result-text mb-0 fw-light" dangerouslySetInnerHTML={{__html: about}}></p>
        </div>
    );
}

export default ResultAbout;